import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.OffboardUserPopupContent.Requests', {
    noData: 'There are no associated open requests.',
    title: 'Please select replacement for {displayName} for:',
    allOpenRequests: 'For all open requests',
    countOpenRequests: 'For {count} open request(s)',
    eachOpenRequest: 'For each open request separately',
    nameColumn: 'Request name',
    roleAmount: 'Amount',
    stepColumn: 'Step',
    replacementColumn: 'Replacement',
});
